<template>
  <!--
    SEO 说明区块：把「工具介绍 / 能力清单 / 使用步骤 / 常见问题」真实渲染在页面底部。
    ⚠️ 这是刻意做的，不是装饰：
      · 工具站是 Vue SPA，蜘蛛抓到的 index.html 只有一个空 <div id="app">；
      · scripts/prerender.js 会把本区块的同一份数据写进静态 HTML；
      · 两边共用 src/data/tool-seo.js，内容一致，既给蜘蛛可索引的正文，又不构成 cloaking。
    未知路由（如 /tasks）返回 null，不渲染。
  -->
  <section v-if="seo" class="ts-seo">
    <div class="ts-seo-inner">
      <h2 class="ts-seo-h2">{{ seo.h1 }}是什么</h2>
      <p v-for="(para, i) in seo.intro" :key="'p' + i" class="ts-seo-p">{{ para }}</p>

      <h2 class="ts-seo-h2">功能清单</h2>
      <ul class="ts-seo-list">
        <li v-for="item in seo.list" :key="item.name" class="ts-seo-item">
          <span class="ts-seo-name">{{ item.name }}</span>
          <span class="ts-seo-desc">{{ item.desc }}</span>
        </li>
      </ul>

      <h2 class="ts-seo-h2">怎么使用</h2>
      <ol class="ts-seo-steps">
        <li v-for="(step, i) in seo.steps" :key="'s' + i">{{ step }}</li>
      </ol>

      <h2 class="ts-seo-h2">常见问题</h2>
      <dl class="ts-seo-faq">
        <div v-for="item in seo.faq" :key="item.q" class="ts-seo-faqitem">
          <dt>{{ item.q }}</dt>
          <dd>{{ item.a }}</dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<script>
import toolSeo from '../../data/tool-seo.js';

export default {
  name: 'ToolSeoSection',
  props: {
    // 由 commonPage.vue 传入 $route.path
    path: { type: String, default: '' },
  },
  computed: {
    seo() {
      return toolSeo.getToolSeo(this.path);
    },
  },
};
</script>

<style scoped>
.ts-seo {
  border-top: 1px solid rgba(56, 189, 248, 0.16);
  background: rgba(10, 16, 30, 0.55);
  padding: 40px 0 56px;
}

.ts-seo-inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 28px;
}

.ts-seo-h2 {
  margin: 28px 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: #e2f5ff;
  letter-spacing: 0.5px;
}

.ts-seo-h2:first-child {
  margin-top: 0;
}

.ts-seo-p {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.9;
  color: #9fb3d1;
}

.ts-seo-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 10px 18px;
}

.ts-seo-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border: 1px solid rgba(56, 189, 248, 0.14);
  border-radius: 10px;
  background: rgba(56, 189, 248, 0.04);
}

.ts-seo-name {
  font-size: 14px;
  font-weight: 600;
  color: #22d3ee;
}

.ts-seo-desc {
  font-size: 13px;
  line-height: 1.7;
  color: #8fa3c8;
}

.ts-seo-steps {
  margin: 0;
  padding-left: 22px;
  font-size: 14px;
  line-height: 1.9;
  color: #9fb3d1;
}

.ts-seo-faq {
  margin: 0;
}

.ts-seo-faq dt {
  font-size: 14px;
  font-weight: 600;
  color: #e2f5ff;
  margin-top: 14px;
}

.ts-seo-faq dd {
  margin: 4px 0 0;
  font-size: 13.5px;
  line-height: 1.85;
  color: #8fa3c8;
}

@media (max-width: 768px) {
  .ts-seo-inner {
    padding: 0 16px;
  }
}
</style>
